const getters = {
  equipmentsStatusID: state => state.skill.equipment_status.id,
  isEquipmentsOpened: state => state.skill.equipment_status.id === 1,
  isEquipmentsBlockedByCE: state => state.skill.equipment_status.id === 2,
  isEquipmentsBlockedBySpM: state => state.skill.equipment_status.id === 3,
  isEquipmentsBlockedBySeM: state => state.skill.equipment_status.id === 4,
};

export default getters;
